import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import Updates from "./components/Updates";
import HotRank from "./components/HotRank";
import Featured from "./components/Featured";
import Reviews from "./components/Reviews";
import Faq from "./components/Faq";
import AboutContact from "./components/AboutContact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  const [activeCategory, setActiveCategory] = useState("全部");
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <main className="min-h-screen w-full bg-background-50">
      <Navbar onSearch={(kw) => setSearchTerm(kw)} />
      <Hero />
      <Categories active={activeCategory} onSelect={setActiveCategory} />
      <Updates active={activeCategory} onSelect={setActiveCategory} searchTerm={searchTerm} />
      <HotRank />
      <Featured />
      <Reviews />
      <Faq />
      <AboutContact />
      <Footer />
      <BackToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "韩国歪歪漫画",
            url: "https://hahasnap.github.io/",
            inLanguage: "zh-CN",
            description:
              "韩国歪歪漫画聚焦恶搞题材与反转剧情，神展开脑洞、魔性爆笑一网打尽，反转剧情每日更新在线追更。",
          }),
        }}
      />
    </main>
  );
}